(function($){

    $.fn.equalise = function(options) {

        var defaults = {
            minWidth: null,
            property: 'height' //used to be min-width but doesnt work with IE11 and flex-grow
        };
        var settings = $.extend(defaults, options);
        var browser_width = window.innerWidth;
        var blocks = this;
        var max_height = 0;

        if (!settings.minWidth) {
            //ignore setting
        } else if (browser_width < settings.minWidth) {
            return blocks;
        }

        blocks.each(function()
        {
            var this_height = $(this).outerHeight();
            max_height = Math.max(this_height, max_height);
        });

        blocks.each(function()
        {
            var block = $(this);
            block.css(settings.property, max_height);
            // block.trigger('equalise:complete');
            // console.log('equalise completed');
        });

        if (settings.complete !== undefined) {
            // settings.complete();
            console.log('if set complete');
        }

        return blocks;
    };

}(jQuery));



// WEBPACK FOOTER //
// ./packages/OSB/js/plugins/equalise.js